/* eslint-disable @typescript-eslint/dot-notation */
import { Component, ElementRef, AfterViewInit, AfterViewChecked, QueryList, ViewChildren, HostListener } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { DateInputEnum } from '../../models/date-input.enum';
import { DateFormatEnum } from '../../models/date-format.enum';

import { DatePipe } from '@angular/common';
import { MAT_TOOLTIP_DEFAULT_OPTIONS } from '@angular/material/tooltip';
import { ConfigData } from '../../models/configData';
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
    selector: 'se-date-cell-renderer',
    templateUrl: './date-cell-renderer.component.html',
    styleUrls: ['./date-cell-renderer.component.scss'],
    providers: [{ provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: ConfigData.tooltipConfiguration }]
})
export class DateCellRendererComponent implements ICellRendererAngularComp, AfterViewInit, AfterViewChecked {
    public inputType: DateInputEnum;
    public inputFormat: DateFormatEnum;
    public isRequired: boolean;

    value: Date;
    params: ICellRendererParams;
    viewFormat: string;
    tooltipValue: string;
    disabled: boolean;
    dateSeparator: string;
    timeSeparator: string;

    // -------
    formGroup: FormGroup;
    key;
    columnName: string;
    // -------

    isInvalid!: boolean;

    @ViewChildren('cellContent') elementRefs: QueryList<ElementRef>;

    @HostListener('resize', ['$event']) onresizecol(event) {
        this.enableOrDisableTooltip();
    }



    constructor(private datePipe: DatePipe) {
    }


    agInit(params: ICellRendererParams): void {
        this.params = params;
        this.value = params.value;
        this.configCellEditor();
        this.defineViewFormat();
        this.tooltipValue = this.transformDate(this.value);

        // ------ validazione
        this.columnName = params.colDef.headerName;
        this.key = params.context.createKey(params.node, params.column);
        // ------
    }

    ngAfterViewInit(): void {
        this.formGroup = this.params.context.formGroup;
        if (!this.formGroup.controls[this.key]) {
            this.formGroup.addControl(this.key, new FormControl(this.value ? this.value : null, this.isRequired ? [Validators.required] : []));
        }
        this.showStatus(this.formGroup.controls[this.key]);
    }

    ngAfterViewChecked(): void {
        setTimeout(() => this.enableOrDisableTooltip(), 0);
    }

    refresh(params: any): boolean {
        this.formGroup = params.context.formGroup;
        this.value = params.value;
        this.tooltipValue = this.transformDate(this.value);
        if (!this.formGroup.controls[this.key]) {
            this.formGroup.addControl(this.key, new FormControl(null));
        }

        this.formGroup.controls[this.key]?.patchValue(this.value);
        this.showStatus(this.formGroup.controls[this.key]);
        return true;
    }

    private showStatus(control): void {
        if (control?.status === 'INVALID') {
            this.isInvalid = true;
        } else {
            this.isInvalid = false;
        }
    }

    private configCellEditor() {
        this.isRequired = this.params['required'] || false;
        const inputTypeParam = this.params['inputType'];
        this.inputType = inputTypeParam ? inputTypeParam : DateInputEnum.DATE;

        const inputFormatParam = this.params['inputFormat'];
        this.inputFormat = inputFormatParam ? inputFormatParam : DateFormatEnum.SHORT;
        this.dateSeparator = this.params['dateSeparator'] || '/';
        this.timeSeparator = this.params['timeSeparator'] || ':';
    }

    private defineViewFormat() {

        switch (this.inputType) {
            case DateInputEnum.DATE_TIME:
                if (this.inputFormat === DateFormatEnum.SHORT) {

                    this.viewFormat = `dd${this.dateSeparator}MM${this.dateSeparator}yyyy, HH${this.timeSeparator}mm`
                } else {
                    this.viewFormat = 'dd MMMM, y HH:mm:ss';
                }
                break;
            case DateInputEnum.DATE:
                if (this.inputFormat === DateFormatEnum.SHORT) {
                
                    this.viewFormat = `dd${this.dateSeparator}MM${this.dateSeparator}yyyy`
                } else {
                    this.viewFormat = 'dd MMMM, y';
                }
                break;
            case DateInputEnum.TIME:
                if (this.inputFormat === DateFormatEnum.SHORT) {
                   
                    this.viewFormat = `HH${this.timeSeparator}mm`
                } else {
                    this.viewFormat = 'HH:mm:ss';
                }
                break;
        }
    }

    private transformDate(date) {
        return this.datePipe.transform(date, this.viewFormat);
    }

    private enableOrDisableTooltip() {
        if (!this.elementRefs || this.elementRefs.length === 0) {
            this.disabled = true;
        } else {
            let elementRefsArraySorted = this.elementRefs.toArray().sort((a, b) => {
                let aOffsetWidth = a.nativeElement.offsetWidth;
                let bOffsetWidth = b.nativeElement.offsetWidth;
                return aOffsetWidth - bOffsetWidth;
            });
            const element = elementRefsArraySorted.pop().nativeElement;
            this.disabled = this.params ? element.offsetWidth < (this.params.column.getActualWidth() - (element.offsetLeft * 2)) : false;
        }
    }



}
